(() => {
  const roots = document.querySelectorAll(".nlp-circles");
  if (!roots.length) return;

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  roots.forEach((root) => {
    if (root.dataset.init === "1") return;
    root.dataset.init = "1";

    const items = Array.from(root.querySelectorAll(".nlp-circles__item"));
    const circles = Array.from(root.querySelectorAll(".nlp-circles__circle"));
    if (!items.length) return;

    // GSAP path
    if (window.gsap) {
      if (window.ScrollTrigger)
        window.gsap.registerPlugin(window.ScrollTrigger);

      window.gsap.set(items, { opacity: 0, y: 18 });
      window.gsap.to(items, {
        opacity: 1,
        y: 0,
        duration: 0.85,
        ease: "power2.out",
        stagger: 0.08,
        scrollTrigger: window.ScrollTrigger
          ? { trigger: root, start: "top 85%", once: true }
          : undefined,
      });

      // subtle float on circles
      circles.forEach((c, i) => {
        window.gsap.to(c, {
          y: i % 2 === 0 ? -6 : 6,
          duration: 2.8 + i * 0.2,
          ease: "sine.inOut",
          yoyo: true,
          repeat: -1,
        });
      });

      return;
    }

    // Fallback (no GSAP)
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          items.forEach((item, i) => {
            item.style.opacity = "0";
            item.style.transform = "translateY(18px)";
            item.style.transition = "opacity .6s ease, transform .6s ease";
            item.style.transitionDelay = `${i * 70}ms`;

            requestAnimationFrame(() => {
              item.style.opacity = "1";
              item.style.transform = "translateY(0)";
            });
          });

          io.disconnect();
        });
      },
      { threshold: 0.15 },
    );

    io.observe(root);
  });
})();
